import LogoSixense from '@/components/logos/LogoSixense';
import {useMediaQuery} from '@mui/material';

import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';

import {useTheme} from '@mui/material/styles';
import React, {FC, ReactElement} from 'react';

const HalfScreenWrapper: FC<{ children: Array<ReactElement> }> = ({children}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));

  return <Grid container component="main" sx={styles.container}>
    <Grid size={{xs: 0, sm: 4, md: 5}} component={Paper} elevation={6} square sx={styles.logoContainer}>
      <LogoSixense height="7vw" fill="#fff"/>
    </Grid>
    <Grid size={{xs: 12, sm: 8, md: 7}} sx={styles.formContainer}>
      {isXs && <LogoSixense height="14vw" fill={theme.palette.primary.main}/>}
      {children}
    </Grid>
  </Grid>;
};

export default HalfScreenWrapper;

const styles = {
  container: {
    height: '100vh'
  },
  logoContainer: {
    bgcolor: 'primary.main',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    mb: 12,
    position: 'relative'
  },
};
